import {ReactComponent as HelpIcon} from './help.svg'

function Help() {
  return <HelpIcon />
}

export default Help
